/** An FYP feed loading: the first video's still on black, as the Worker painted
 *  it into the page (server/lib/fypPage.ts), so the screen never flashes white. */
export function FypBootFallback() {
  const { fypPoster, fypFit } = document.documentElement.dataset;
  return (
    <div className="fixed inset-0 bg-black">
      {fypPoster && (
        <img
          src={fypPoster}
          alt=""
          className="absolute inset-x-0 top-0 mx-auto w-full max-w-[min(100vw,calc(100dvh*9/16))]"
          // The feed's tab bar takes the bottom (FypTabBar), so the still stops above it;
          // a funnel's FYP version has no tab bar (data-fyp-bar="0").
          style={{
            objectFit: fypFit === "contain" ? "contain" : "cover",
            height: document.documentElement.dataset.fypBar === "0" ? "calc(100% - 2px)" : "calc(100% - 56px - env(safe-area-inset-bottom))",
          }}
        />
      )}
    </div>
  );
}
